import { createContext, useContext } from 'react'

/** @typedef {import('./alert').Alert} Alert */

export const AlertContext = createContext()

/** @returns {Alert} */
export function useAlert() {
  return useContext(AlertContext)
}
